/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { formatMessage } from "src/helpers/common";

export default function PaymentSuccessPopup({ open, closeHandler }) {
  const { t } = useTranslation();

  const handleClose = () => {
    closeHandler();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Stack direction={"row"} gap={1}>
          {t("admin.subscription.success.title")}
          <CheckCircleIcon color="success" fontSize="large" />
        </Stack>
      </DialogTitle>
      <DialogContent>
        {formatMessage(t("admin.subscription.success.content"))}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
